import { define } from '../redux-request';
import api from '../../api/api';

export const GET_PRODUCTS = define('GET_PRODUCTS');

export function getProductsRequest(data) {
  return GET_PRODUCTS.request(() => api.getProducts(data));
}

export const GET_INVENTORY = define('GET_INVENTORY');

export function getInventoryRequest(data) {
  return GET_INVENTORY.request(() => api.getInventory(data));
}

export const GET_PRODUCT_ORDER = define('GET_PRODUCT_ORDER');

export function getProductOrderRequest(data) {
  return GET_PRODUCT_ORDER.request(() => api.getProductOrder(data));
}

export const GET_ADJUST_PRODUCT = define('GET_ADJUST_PRODUCT');

export function getAdjustProductRequest(data) {
  return GET_ADJUST_PRODUCT.request(() => api.getAdjustProduct(data));
}

export const CLEAR_ADJUST_PRODUCT = define('CLEAR_ADJUST_PRODUCT');

export function clearAdjustProduct() {
  return { type: CLEAR_ADJUST_PRODUCT };
}

export const UPLOAD_XLSX_PRODUCT_FILE = define('UPLOAD_XLSX_PRODUCT_FILE');

export function productUploadXLSXFileRequest(data) {
  return UPLOAD_XLSX_PRODUCT_FILE.request(() => api.productUploadXLSXFile(data));
}

export const UPLOAD_ZIP_PRODUCT_FILE = define('UPLOAD_ZIP_PRODUCT_FILE');

export function productUploadZipDileRequest(data) {
  return UPLOAD_ZIP_PRODUCT_FILE.request(() => api.productUploadZipFile(data));
}
